module.exports = __webpack_public_path__ + "static/media/er.cf379aed.svg";